import AboutTurnCom from '../AboutTurnCom';
import { TypeAboutTurn } from '../types/TypesDocsId';
import { baseURLApi } from '@/lib/servies/axiosConfig';
import hospitalIcon from '@/assets/image/hospital 1.svg';
import Image from 'next/image';
import TurnPreview from './turn-preview';

export default async function AboutTurn(props: TypeAboutTurn) {
    const {
        matabData,
        clinicsData,
        idDoctor,
        nameDoc,
        matab_plus,
        service_plus,
        turnData,
        isTurnOn,
        firstDateTimes,
    } = props;

    let data;
    if (turnData?.months) {
        data = turnData;
    } else {
        const res = await fetch(`${baseURLApi}/doctor_first_turn`, {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: idDoctor }),
        });

        data = await res.json();
    }
    const hasTurns = (t: string): boolean => {
        return t?.toLowerCase() === 'yes';
    };

    const allClinics = [
        {
            ...matabData,
            turns: isTurnOn,
            clinic_name: 'مطب',
            Foreign_clinic: '',
        },

        ...clinicsData.map((clinic) => {
            const newClinic = data?.result?.clinics_first.find(
                (c: { id: string }) => c.id === clinic.id,
            );

            return {
                ...clinic,
                turns: newClinic?.turns,
                clinic_name: 'درمانگاه',
                Foreign_clinic: 'درمانگاه',
            };
        }),
    ];
    const sortedClinics = allClinics.slice().sort((a, b) => {
        const aHasTurn = hasTurns(a.turns);
        const bHasTurn = hasTurns(b.turns);

        if (aHasTurn && !bHasTurn) return -1;
        if (!aHasTurn && bHasTurn) return 1;
        return 0;
    });

    return (
        <div
            className="flex flex-col gap-3 order-first p-4 md:!p-6 bg-white rounded-2xl shadow-m"
            id="get_turn"
        >
            <div className="flex items-start gap-2 justify-between">
                <div className="flex gap-2 items-center">
                    <Image
                        alt={`نوبت دهی اینترنتی دکتر ${nameDoc}`}
                        width={24}
                        height={24}
                        src={hospitalIcon}
                    />
                    <h2 className="font-bold sm:!text-base text-sm">
                        {`نوبت دهی اینترنتی دکتر ${nameDoc}`}
                    </h2>
                </div>
                {/* <Button className='!bg-white !h-[28px] gap-1 !px-0 !py-0 flex !text-[#222222A3]'>
                <IoMdInformationCircleOutline className='text-lg'/>
                راهنما
                </Button> */}
            </div>

            <div className="space-y-6">
                {sortedClinics &&
                    (sortedClinics.length > 1 ? (
                        sortedClinics.map((clinic, index) => (
                            <AboutTurnCom
                                key={index}
                                nameDoc={nameDoc}
                                {...clinic}
                                idDoctor={idDoctor}
                            />
                        ))
                    ) : sortedClinics[0].turns === 'no' ? (
                        <AboutTurnCom
                            nameDoc={nameDoc}
                            {...sortedClinics[0]}
                            idDoctor={idDoctor}
                        />
                    ) : (
                        <TurnPreview
                            nameDoc={nameDoc}
                            {...sortedClinics[0]}
                            data={turnData}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            firstDateTimes={firstDateTimes as any}
                            idDoctor={idDoctor}
                        />
                        // <AboutTurnCom
                        //     nameDoc={nameDoc}
                        //     {...sortedClinics[0]}
                        //     idDoctor={idDoctor}
                        // />
                    ))}

                {matab_plus &&
                    matab_plus.length > 0 &&
                    matab_plus.map((item) => (
                        <AboutTurnCom
                            turnSatus="matab-plus"
                            turns="yes"
                            key={item.id}
                            nameDoc={nameDoc}
                            clinic_name={item.title}
                            Foreign_clinic={'مطب'}
                            {...item}
                            idDoctor={idDoctor}
                            id={String(item.id)}
                            phone={item.phone}
                        />
                    ))}
                {service_plus &&
                    service_plus.length > 0 &&
                    service_plus.map((item) => (
                        <AboutTurnCom
                            turnSatus="matab-plus"
                            turns="yes"
                            key={item.id}
                            nameDoc={nameDoc}
                            clinic_name={item.title}
                            Foreign_clinic={'مطب'}
                            {...item}
                            idDoctor={idDoctor}
                            id={String(item.id)}
                        />
                    ))}
            </div>
        </div>
    );
}
